import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPointRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 6.375C0.541667 6.375 0.364583 6.44792 0.21875 6.59375C0.0729167 6.73958 0 6.91667 0 7.125C0 7.33333 0.0729167 7.51042 0.21875 7.65625C0.364583 7.80208 0.541667 7.875 0.75 7.875H13.125L8.40625 12.5938C8.26042 12.7396 8.1875 12.9167 8.1875 13.125C8.1875 13.3333 8.26042 13.5104 8.40625 13.6562C8.55208 13.8021 8.72917 13.875 8.9375 13.875C9.14583 13.875 9.32292 13.8021 9.46875 13.6562L16 7.125L9.46875 0.59375C9.32292 0.447917 9.14583 0.375 8.9375 0.375C8.72917 0.375 8.55208 0.447917 8.40625 0.59375C8.26042 0.739583 8.1875 0.916667 8.1875 1.125C8.1875 1.33333 8.26042 1.51042 8.40625 1.65625L13.125 6.375H0.75Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgPointRight);
export default ForwardRef;
